module.exports = __webpack_public_path__ + "static/media/promotionTemplate.2286ed97.xlsx";